module.exports = __webpack_public_path__ + "img/avator.e46960b0.png";